'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var GET = 'GET';

var PATCH = 'PATCH';
var POST = 'POST';
var DELETE = 'DELETE';

var FETCH_PROCESSING = 'FETCH_PROCESSING';
var FETCH_SUCCESS = 'FETCH_SUCCESS';
var FETCH_FAILURE = 'FETCH_FAILURE';

var INITIAL_STATE = {
  loaded: false,
  processing: false
};

exports.GET = GET;
exports.PATCH = PATCH;
exports.POST = POST;
exports.DELETE = DELETE;
exports.FETCH_PROCESSING = FETCH_PROCESSING;
exports.FETCH_SUCCESS = FETCH_SUCCESS;
exports.FETCH_FAILURE = FETCH_FAILURE;
exports.INITIAL_STATE = INITIAL_STATE;
